module.exports = "./assets/assets/合同公告模板.d0838bc3.docx";